/* ==========================================================================
   Peinture Nature - page collection
   JavaScript natif. Amelioration progressive uniquement : tout fonctionne
   sans ce fichier, il ne fait que rendre l'experience plus confortable.
   ========================================================================== */

/* ----- 1. Tri sans bouton ------------------------------------------------
   Le formulaire de tri est un vrai formulaire GET : sans JavaScript il faut
   un bouton Envoyer. Avec, le changement suffit. Les filtres actifs sont
   deja reemis en champs caches par le gabarit, ils ne sont donc pas perdus. */
const formTri = document.querySelector('[data-pn-tri]');
if (formTri) {
  const select = formTri.querySelector('select');
  const bouton = document.createElement('button');
  bouton.type = 'submit';
  bouton.className = 'pn-lecteur-seul';
  bouton.textContent = 'Trier';
  formTri.appendChild(bouton);
  select.addEventListener('change', () => formTri.submit());
}

/* ----- 2. Pagination -----------------------------------------------------
   DECISION DU 2026-07-30, apres question de Pablo : « le bouton voir plus,
   c'est bien d'un point de vue SEO et UX ? »

   Verdict : non, pas ici. Le bouton a ete RETIRE, la numerotation reste seule.

   Cote SEO. Le cahier des charges reprenait la pagination hybride de Poster
   Store. Mais pour la garder sans doublon visuel, je masquais la numerotation
   des que le bouton fonctionnait. Or masquer visuellement des liens de
   navigation tout en les laissant dans le code est exactement le genre de
   construction qu'on evite : le benefice est nul, puisque Google explore deja
   les URL paginees, et le risque de lecture defavorable est reel. Une
   numerotation simplement visible ne pose aucune question.

   Cote UX. Le chargement progressif casse trois choses sur un catalogue de
   1 525 produits : le bouton Retour ne ramene pas au bon endroit, le pied de
   page devient difficile a atteindre, et la position de defilement se perd au
   rechargement. Aucune des 8 references du panel n'utilise le defilement
   infini pur, et la moitie garde une numerotation seule.

   Ce qui reste : 40 produits par page au lieu de 20, ce qui divise deja le
   nombre de pages par deux, et une numerotation lisible.
*/

/* ----- 3. Panneau de filtres --------------------------------------------
   Le composant pn-panneau vit dans theme.js et sert aussi au tiroir de
   panier et au menu mobile : un seul composant, pas un par surface.
   Ici on ne fait que tenir aria-expanded a jour sur le declencheur. */
const panneau = document.getElementById('pn-panneau-filtres');
if (panneau) {
  const declencheur = document.querySelector('[data-pn-ouvre="pn-panneau-filtres"]');
  const sync = () => declencheur?.setAttribute('aria-expanded', String(!panneau.hidden));
  new MutationObserver(sync).observe(panneau, { attributes: true, attributeFilter: ['hidden'] });

  /* En BUREAU, le meme panneau devient une colonne laterale permanente.
     La feuille de style le replace, mais elle ne peut pas defaire ce qui
     releve de l'accessibilite : sans ces trois lignes, une colonne
     parfaitement visible resterait annoncee comme un dialogue masque.
     C'est la meme instance qu'en telephone, donc aucun poids en plus. */
  const enColonne = !!document.querySelector('.pn-col--facettes-colonne');
  const large = matchMedia('(min-width: 990px)');
  const adapter = () => {
    if (large.matches && enColonne) {
      panneau.hidden = false;
      panneau.removeAttribute('aria-hidden');
      panneau.removeAttribute('aria-modal');
      panneau.setAttribute('role', 'region');
    } else {
      panneau.hidden = true;
      panneau.setAttribute('aria-hidden', 'true');
      panneau.setAttribute('aria-modal', 'true');
      panneau.setAttribute('role', 'dialog');
    }
  };
  adapter();
  large.addEventListener('change', adapter);

  /* Compteur de resultats en direct sur le bouton d'envoi : le nombre
     affiche est celui de la page courante tant qu'on n'a pas valide. On
     signale donc au moins que la selection a change, sans mentir sur un
     total qu'on ne connait pas avant la requete. */
  const form = panneau.querySelector('form');

  /* CEINTURE ET BRETELLES sur les champs vides. Un champ de prix laisse vide
     partirait dans l'adresse sous la forme `filter.v.price.gte=`, que Shopify
     lit comme une borne a zero et non comme une absence de borne. On desactive
     donc les champs vides juste avant l'envoi : un champ desactive n'est pas
     transmis, et l'adresse reste propre. */
  form?.addEventListener('submit', () => {
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach((champ) => {
      if (champ.value.trim() === '') champ.disabled = true;
    });
  });

  const envoi = form?.querySelector('[type="submit"]');
  if (form && envoi) {
    const initial = envoi.textContent.trim();
    form.addEventListener('change', () => {
      envoi.textContent = envoi.dataset.pnAttente || initial;
    });
  }
}


/* ----- 4. Repli du texte SEO de collection --------------------------------
   Demande de Pablo : « pourquoi ne pas faire un afficher plus comme sur
   Western afin de pouvoir facilement acceder au footer, tout en gardant le
   texte lisible par Google ».

   Amelioration progressive : le repli est POSE PAR LE SCRIPT. Sans lui, le
   texte reste entier et accessible. Le contenu n'est jamais en display none,
   seulement rogne par overflow, donc il reste du contenu rendu pour Google.
   On ne replie pas non plus un texte deja court, ce serait un clic pour rien. */
const seoContenu = document.querySelector('[data-pn-seo-contenu]');

if (seoContenu && seoContenu.scrollHeight > 300) {
  const bouton = document.createElement('button');
  bouton.type = 'button';
  bouton.className = 'pn-col-seo__bouton';
  bouton.setAttribute('aria-controls', 'pn-seo-contenu');
  seoContenu.id = 'pn-seo-contenu';

  const majuscule = (etat) => {
    bouton.textContent = etat ? 'Afficher moins' : 'Afficher plus';
    bouton.setAttribute('aria-expanded', String(etat));
  };

  seoContenu.classList.add('pn-col-seo__contenu--replie');
  majuscule(false);
  seoContenu.after(bouton);

  bouton.addEventListener('click', () => {
    const replie = seoContenu.classList.toggle('pn-col-seo__contenu--replie');
    majuscule(!replie);
    if (replie) seoContenu.scrollIntoView({ block: 'nearest' });
  });
}
